/**
 * @desc 基本常用工具集
 */
import Cookies from 'js-cookie';
import JSEncrypt from 'jsencrypt';
import { publicKey } from '@/global.js';
import { v4 as uuidv4 } from 'uuid';
import { Base64 } from './util';

export const uuid = () => {
  return uuidv4();
};

export const getHistoryAccounts = () => {
  return JSON.parse(localStorage.getItem('historyAccounts') || `[]`);
};

const setHistoryAccounts = (accounts = []) => {
  localStorage.setItem('historyAccounts', JSON.stringify(accounts));
};

export const addHistoryAccount = (account) => {
  const accounts = getHistoryAccounts();
  if (accounts.indexOf(account) === -1) {
    accounts.push(account);
    setHistoryAccounts(accounts);
  }
};

/**
 * @desc 设置取token
 * @returns {*}
 */
export const setCookieInfo = (key, value, expires) => {
  let domainVal = '';
  if (location.hostname.indexOf('.com') >= 0) {
    domainVal = `.${location.hostname.split('.').slice(-2).join('.')}`;
  } else {
    domainVal = location.hostname;
  }
  Cookies.set(key, Base64.ec(value), { domain: domainVal, expires: expires || 99999 });
};

/**
 * @desc 获取token
 * @returns {*}
 */
export const getCookieInfo = () => {
  const info = {
    token: Base64.dc(Cookies.get('123cx@token') || ''),
  };
  return info;
};

/**
 * @desc 清除token相关信息
 */
export const removeCookieInfo = () => {
  let domainVal = '';
  if (location.hostname.indexOf('.com') >= 0) {
    domainVal = `.${location.hostname.split('.').slice(-2).join('.')}`;
  } else {
    domainVal = location.hostname;
  }
  Cookies.set('123cx@token', '', { domain: domainVal });
  localStorage.removeItem('store@session');
};

export const logout = (redirect) => {
  if (window.location.href.indexOf('/#/login') > 0) return;
  window.location.href = `/#/login${redirect ? `?redirect=${redirect}` : ''}`;
};

/**
 * 公钥加密
 * @param value
 */
export const encrypt = (value) => {
  const j = new JSEncrypt();
  j.setPublicKey(publicKey);
  return j.encrypt(value);
};

/**
 * desc常用类型
 * @type {{number: string, boolean: string, string: string, array: string, function: string, error: string, object: string}}
 */
export const typeMap = {
  undefined: 'undefined',
  null: 'null',
  boolean: 'boolean',
  number: 'number',
  string: 'string',
  symbol: 'symbol',
  object: 'object',
  function: 'function',
  array: 'array',
  error: 'error',
};

/**
 * @desc 获取value类型
 * @param value
 * @return {string}
 */
export const typeQuery = (value) => ({}).toString.call(value).toLowerCase().slice(8, -1).trim();
Object.keys(typeMap).forEach((key) => typeQuery[key] = typeMap[key]);

